import { ButtonType, ButtonWidget, TabStyles } from '@tableau/widgets';
import * as React from 'react';
import { Messages, Formatters } from '../../codegen/Localize';
import { cssClass, Style } from '../../style';
import _ = require('underscore');
import { style } from 'typestyle';
import { CommonStyles } from '../../common/react/CommonStyles';

const borderRadiusValue: string = '4px';

export type DraftBannerAction = {
  label: string;
  iconPath: string;
  handleAction: () => void;
  testId: string;
}

export type DraftBannerProps = {
  readonly lastEditDate: string;
  readonly contentTypeName: string;
  readonly draftBannerActions: DraftBannerAction[];
};

const DraftBannerWrapperClass = cssClass('DraftBannerWrapperClass', '', {
  display: 'inline-flex',
  height: '44px',
  backgroundColor: '#ebebeb',
  alignItems: 'center',
  borderRadius: borderRadiusValue,
});

const DraftStatusWrapperClass = cssClass('DraftStatusWrapper', '', {
  display: 'flex',
  alignItems: 'center',
  backgroundColor: CommonStyles.Colors.BadgeBlue,
  height: '100%',
  borderRadius: `${borderRadiusValue} 0 0 ${borderRadiusValue}`
});

const DraftStatusTextClass = cssClass('DraftStatusText', '', {
  fontWeight: 'bold',
  fontSize: '14px',
  color: '#fafafa',
  padding: `0 ${TabStyles.Spacing.LargeSpace}px`,
});

const DateWrapperClass = cssClass('DateWrapperClass', '', {
  paddingLeft: TabStyles.Spacing.LargeSpace,
  paddingRight: '50px',
});

const ButtonsWrapperClass = cssClass('ButtonsWrapperClass', '', {
  display: 'flex',
});

const ButtonClass = cssClass('ButtonWrapperClass', '', {
  paddingRight: '32px',
});

const ButtonLabelClass = cssClass('ButtonLabelClass', '', {
  marginLeft: TabStyles.Spacing.DefaultSpace,
});

const buttonHoverStyle: Style = {
  $nest: {
    '&:hover:enabled': {
      textDecoration: 'underline',
      cursor: 'pointer'
    },
  },
};

const InlineButtonStyles: React.CSSProperties = {
  padding: `${TabStyles.Spacing.SmallSpace}px ${TabStyles.Spacing.DefaultSpace}px`,
  display: 'inline-flex',
  alignItems: 'center',
};

function renderButtons(draftBannerActions: DraftBannerAction[]): JSX.Element[] {
return _.map(draftBannerActions, (draftBannerAction: DraftBannerAction) => {
  return (
    <div className={ButtonClass} key={`${draftBannerAction.testId}-key`}>
      <ButtonWidget
        className={style(buttonHoverStyle)}
        buttonType={ButtonType.LowEmphasis}
        testId={`draft-banner-${draftBannerAction.testId}`}
        handleClick={draftBannerAction.handleAction}
        title={draftBannerAction.label}
        style={InlineButtonStyles}
      >
        <img data-tb-test-id={'draft-banner-action-button-icon'} src={draftBannerAction.iconPath}/>
        <span data-tb-test-id={'draft-banner-action-button-label'} className={ButtonLabelClass}>
          {draftBannerAction.label}
        </span>
      </ButtonWidget>
    </div>
    );
  });
}

export function DraftBanner(props: DraftBannerProps): JSX.Element {
  return (
    <div data-tb-test-id={'draft-banner'} className={DraftBannerWrapperClass} >
      <div className={DraftStatusWrapperClass}>
        <span className={DraftStatusTextClass}>{Messages.draftBannerHeader()}</span>
      </div>
      <div className={DateWrapperClass}>
        <span data-tb-test-id={'draft-banner-last-edited-message'}>
          {Messages.lastEdited({CONTENT_TYPE: props.contentTypeName, RELATIVE_DATE: Formatters.formatLongBestFitRelativeTime(new Date(props.lastEditDate))})}
        </span>
      </div>
      <div className={ButtonsWrapperClass}>
        {renderButtons(props.draftBannerActions)}
      </div>
    </div>
  );
}
